module.exports = __webpack_public_path__ + "images/tencent_docs/sheet-grid-46fb0adf38657b1202061c4fc42f511b.png";